import { jsx, jsxs } from 'react/jsx-runtime';
import { Children } from 'react';
import { getChildByDisplayName } from '@belong/common/getChildByDisplayName';
import { getChildByName } from '@belong/common/getChildByName';
import { Root, Thumb } from '@radix-ui/react-switch';
import clsx from 'clsx';
import { WRAPPER_SIZE_MAP, ROOT_BACKGROUND_STYLES, ROOT_BORDER_STYLES, ROOT_SIZE_MAP, THUMB_BACKGROUND_STYLES, THUMB_SIZE_MAP, THUMB_TRANSLATION_MAP } from './Switch.constants.js';
import { SwitchProvider } from './Switch.context.js';
import { LeftSlot } from './components/LeftSlot/LeftSlot.js';
import { RightSlot } from './components/RightSlot/RightSlot.js';

function Switch({
  children,
  checked,
  disabled = false,
  id,
  onChange,
  size = 'default'
}) {
  const left = getChildByDisplayName({
    children,
    displayName: 'Switch.Left'
  }) ?? getChildByName({
    children,
    name: 'LeftSlot'
  });
  const right = getChildByDisplayName({
    children,
    displayName: 'Switch.Right'
  }) ?? getChildByName({
    children,
    name: 'RightSlot'
  });
  return jsx(SwitchProvider, {
    checked: checked,
    id: id,
    size: size,
    slotCount: Children.count(children),
    children: jsxs("div", {
      className: clsx('group/wrapper flex items-center justify-center hover:cursor-pointer', WRAPPER_SIZE_MAP[size], disabled && 'hover:cursor-default'),
      children: [left, jsx(Root, {
        className: clsx('group relative rounded-full outline-none transition-all duration-hover group-hover/wrapper:cursor-pointer group-hover/wrapper:radix-disabled:cursor-default', ROOT_BACKGROUND_STYLES, ROOT_BORDER_STYLES, ROOT_SIZE_MAP[size]),
        checked: checked,
        disabled: disabled,
        id: id,
        onCheckedChange: onChange,
        children: jsx(Thumb, {
          className: clsx('block rounded-full transition-all duration-hover group-radix-disabled:cursor-default', THUMB_BACKGROUND_STYLES, THUMB_SIZE_MAP[size], THUMB_TRANSLATION_MAP[size])
        })
      }), right]
    })
  });
}
Switch.Left = LeftSlot;
Switch.Right = RightSlot;

export { Switch };
